<template>
    <div class="add-new-client">
        <md-dialog :md-active.sync="showDialog" >
          <validation-observer v-slot="{ handleSubmit }" tag="div">
            <form @submit.prevent="handleSubmit(addNewClient)" class="form">
              <md-dialog-title>
                  <span>New Brand for {{client.name}}</span>
                  <button class="btn btn--close" @click="cancel"></button>
              </md-dialog-title>
              <div class="form__content">
                <ValidationProvider :rules="{required :true, min:3}"  v-slot="{ errors }" tag="div">
                  <md-field>
                    <md-icon v-if="error.name" class="md-accent">warning</md-icon>
                    <label>Brand name</label>
                    <md-input v-model="brand.name" />
                  </md-field>
                  <div class="form__error">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                  <md-field>
                    <md-icon v-if="error.logo" class="md-accent">warning</md-icon>
                    <label>Brand logo</label>
                      <div class="md-file">
                        <input readonly="readonly" class="md-input" v-model="fileNamesToUpload" />
                        <input type="file" accept="image/*" @change="filesSelected" />
                      </div>
                  </md-field>
                  <div class="form__error">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <md-dialog-actions>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                  </div>
                  <div class="md-layout-item text-right">
                  <md-button class="md-primary modal-save-btn" type="submit">Save Brand</md-button>
                  </div>
                </div>
              </md-dialog-actions>
            </form>
          </validation-observer>
        </md-dialog>

        <div class='buttonContainer'>
            <!-- btn on client page -->
            <button v-if="btnclass" :class="btnclass" @click="showDialog = true">ADD NEW BRAND</button>
            <!-- btn on dashboard's left side -->
            <button v-else class="btn add-new-brand-expension" @click="showDialog = true">ADD BRAND</button>
        </div>
    </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, min} from 'vee-validate/dist/rules';import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "This field is required."
});
extend('min', {
  ...min,
  message: "This field should contain at least 3 letters"
});

export default {
  mixins: [apiHandlerMI],
  props: ['client', 'refreshClient', 'btnclass'],
  data(){
    return{
      showDialog: false,
      active: false,
      brand : {
        name: '',

      },
      error: {},

      needUpload : false,
      type: 'square',
      filesToUpload: null,
      fileNamesToUpload: undefined,
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
    methods:{
      filesSelected(event) {
        this.needUpload = true;
        this.client.logo = undefined;
        this.filesToUpload = event.target.files;
        this.fileNamesToUpload = this.filesToUpload[0].name
      },
      upload_selected: function(num = 0) {
        if (!this.needUpload)
          return false;
        const _this = this;
        if (!(this.filesToUpload || []).length) {

          this.error.logo = "Image required!";
          this.$forceUpdate();
          return;
        }
        if (!this.type) {
          this.error.logo  = "Type required!";
          this.$forceUpdate();
          return;
        }
         this.error.logo  = undefined;
        if (this.filesToUpload.length <= num) {
          this.fileNamesToUpload = undefined;
          //this.uploadSuccess = `You have successfully uploaded ${num} files`;
          setTimeout(() => {
            _this.uploadSuccess = undefined;
          }, 3000);
          return;
        }

        let file = this.filesToUpload[num];

        const formData = new FormData();
        formData.append("files[0]", file);
        formData.append('payment_cluster_id',this.client.payment_cluster_id)
        formData.append("folder",'brands');
        formData.append("upload_type", this.type);

        var url = "image";
        if (this.filesToUpload[num].type == "application/pdf") url = "document";
        //console.log("start_upload");
        this.post(
          "filemanager/upload/" + url,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          },
          function(resp) {
            _this.needUpload = false;
            _this.brand.logo = resp.data.images[0].id
            _this.addClientData();
            //_this.upload_selected(num + 1);
          }
        );
      },
      addNewClient(){

        this.upload_selected();
      },
      addClientData(){
        const _this = this;
        _this.brand.client_id = this.client.id;

        this.post('brand',this.brand,{},function(resp){
          // console.log(resp.data);
          console.log("addClientData")
          
          _this.brand = {
            name: '',            
            id: resp.data.result.brand.id       
          };
          
          _this.showDialog = false
          _this.addUserToBrand()

          if (_this.refreshClient) {            
            _this.refreshClient()
          }          
          
          // if (_this.$parent.refreshBrand) {            
          //   _this.$parent.refreshBrand()
          // }        
                      
          _this.filesToUpload = null
          _this.fileNamesToUpload = undefined          
            
        },function(err){          
          console.log(err);
          _this.error = err
          _this.$forceUpdate();
        })
      },
      cancel(){
        this.showDialog = false

      },
      addUserToBrand(){
        let _this = this        

        if (this.$store.state.user){
            let currentUserIid = this.$store.state.user.id

            this.post(
              'user_to_brand',
              {
                user_id:currentUserIid,
                brand_id: _this.brand.id
              },
              {},
              function(){                              
                if (_this.$parent.refreshBrand){                                    
                  _this.$parent.refreshBrand()
                }                  

                if (_this.$parent.$parent.refreshBrand){                                    
                  _this.$parent.$parent.refreshBrand()
                }  

                _this.brand.id=""
              },function(err){                   
                console.log(err)       
                _this.error = err
                _this.$forceUpdate();
              }
            )

        }

      }
    }
 }

</script>